import acidityLow from '../assets/illustrations/taste-acidity-low.webp';
import acidityMedium from '../assets/illustrations/taste-acidity-medium.webp';
import acidityHigh from '../assets/illustrations/taste-acidity-high.webp';
import bodyLight from '../assets/illustrations/taste-body-light.webp';
import bodyMedium from '../assets/illustrations/taste-body-medium.webp';
import bodyFull from '../assets/illustrations/taste-body-full.webp';
import sweetnessDry from '../assets/illustrations/taste-sweetness-dry.webp';
import sweetnessOffDry from '../assets/illustrations/taste-sweetness-off-dry.webp';
import sweetnessMedium from '../assets/illustrations/taste-sweetness-medium.webp';
import sweetnessSweet from '../assets/illustrations/taste-sweetness-sweet.webp';

const BASE = 'https://cmrrsjwbbeurszecszhg.supabase.co/storage/v1/object/public/questionicons/';

// Labels and photos both collide across these questions: "Medium" is a body and
// a sweetness option, Dry/Off-dry share one photo, Medium/Sweet share another,
// and Cream.jpeg is also the dairy flavour icon. Only a label + photo pair
// identifies the option, so neither is enough alone. Keys are lowercase.
const TASTE_SCALE_ICONS = new Map([
  ['low acidity|low acidity.jpeg', acidityLow],
  ['medium acidity|medium acidity.jpeg', acidityMedium],
  ['high acidity|high acidity.jpeg', acidityHigh],
  ['light|water.jpeg', bodyLight],
  ['medium|milk.jpeg', bodyMedium],
  ['full|cream.jpeg', bodyFull],
  ['dry|low sugar.jpeg', sweetnessDry],
  ['off-dry|low sugar.jpeg', sweetnessOffDry],
  ['medium|high sugar.png', sweetnessMedium],
  ['sweet|high sugar.png', sweetnessSweet],
]);

// The file name under the questionicons bucket (the data has both `questionicons/x`
// and `questionicons//x`), or null for any other URL.
function iconFileName(src) {
  if (typeof src !== 'string' || !src.startsWith(BASE)) return null;
  try {
    return decodeURIComponent(src.slice(BASE.length).split(/[?#]/)[0]).replace(/^\/+/, '').toLowerCase();
  } catch { return null; }
}

/**
 * Returns the bundled taste-scale icon for an acidity, body or sweetness option,
 * or null when the label and its stored photo are not one of the ten known pairs.
 */
export function tasteScaleImage(label, src) {
  const file = iconFileName(src);
  if (!file || typeof label !== 'string') return null;
  return TASTE_SCALE_ICONS.get(`${label.trim().toLowerCase()}|${file}`) || null;
}
